import { Bell, MessageCircle } from "lucide-react";
import { Link } from "react-router-dom";

import { useMessagingEnabled } from "../../hooks/useMessagingEnabled";
import { useMessagesStore } from "../../stores/messages";
import { useNotificationsStore } from "../../stores/notifications";

export function DashboardHeaderBadges({
  feedUnreadCount,
}: {
  /** Explicit null hides the badge; omission reads the shared app-wide store. */
  feedUnreadCount?: number | null;
}) {
  const messagingEnabled = useMessagingEnabled();
  const messagesUnreadCount = useMessagesStore((state) => state.unreadCount);
  const storedFeedUnreadCount = useNotificationsStore(
    (state) => state.unreadCount,
  );
  const resolvedFeedUnreadCount =
    feedUnreadCount === undefined ? storedFeedUnreadCount : feedUnreadCount;

  return (
    <>
      <Link
        to="/feed"
        className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition hover:bg-accent hover:text-foreground"
        aria-label={
          resolvedFeedUnreadCount != null && resolvedFeedUnreadCount > 0
            ? `${resolvedFeedUnreadCount} unread notification${resolvedFeedUnreadCount === 1 ? "" : "s"}`
            : "Open notifications"
        }
        data-testid="header-bell"
      >
        <Bell className="h-4 w-4" />
        {resolvedFeedUnreadCount != null && resolvedFeedUnreadCount > 0 ? (
          <span
            className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[0.625rem] font-bold leading-none text-primary-foreground tabular-nums"
            data-testid="header-bell-badge"
          >
            {resolvedFeedUnreadCount > 99 ? "99+" : resolvedFeedUnreadCount}
          </span>
        ) : null}
      </Link>

      {messagingEnabled ? (
        <Link
          to="/threads"
          className="relative inline-flex h-9 w-9 items-center justify-center rounded-full border border-border bg-card text-muted-foreground transition hover:bg-accent hover:text-foreground"
          aria-label={
            messagesUnreadCount != null && messagesUnreadCount > 0
              ? `${messagesUnreadCount} unread conversation${messagesUnreadCount === 1 ? "" : "s"}`
              : "Open messages"
          }
          data-testid="header-messages"
        >
          <MessageCircle className="h-4 w-4" />
          {messagesUnreadCount != null && messagesUnreadCount > 0 ? (
            <span
              className="absolute -right-1 -top-1 flex h-4 min-w-4 items-center justify-center rounded-full bg-primary px-1 text-[0.625rem] font-bold leading-none text-primary-foreground tabular-nums"
              data-testid="header-messages-badge"
            >
              {messagesUnreadCount > 99 ? "99+" : messagesUnreadCount}
            </span>
          ) : null}
        </Link>
      ) : null}
    </>
  );
}
